import axios from 'axios';
import config from '@/config';
import { buildAxiosGetConfigWithRepeatedKey } from '@/features/common/utils/axiosQueryUtil';

const { iffApi } = config.ctx;

/**
 * 材料台账与领用 API 服务
 */
export const materialService = {
  /** 查询材料台账统计（种类数/库存状态分布/本月领用次数） */
  getStatistics: () => axios.get(`${iffApi}/material/statistics`),

  /** 分页查询材料台账列表 */
  queryMaterialPage: (params) => axios.get(`${iffApi}/material/page`, { params }),

  /** 新增材料 */
  saveMaterial: (data) => axios.post(`${iffApi}/material/save`, data),

  /** 编辑材料 */
  updateMaterial: (data) => axios.post(`${iffApi}/material/update`, data),

  /** 删除材料（逻辑删除） */
  deleteMaterial: (uuid) => axios.delete(`${iffApi}/material/delete/${uuid}`),

  /** 材料入库操作 */
  stockIn: (data) => axios.post(`${iffApi}/material/stockIn`, data),

  /** 分页查询入库记录 */
  queryMaterialInPage: (params) => axios.get(`${iffApi}/material/in/page`, { params }),

  /** 发起领用申请 */
  applyOut: (data) => axios.post(`${iffApi}/material/out/apply`, data),

  /** 审批通过 */
  approveOut: (data) => axios.post(`${iffApi}/material/out/approve`, data),

  /** 审批拒绝 */
  rejectOut: (data) => axios.post(`${iffApi}/material/out/reject`, data),

  /** 一体化申请并下载领用单（faultId 必填；返回 blob 文件流） */
  applyAndDownloadOut: (data) => axios.post(`${iffApi}/material/out/applyAndDownload`, data, { responseType: 'blob' }),

  /** 历史下载领用单（通过领用记录 uuid 取已存档文件） */
  downloadApplyFile: (uuid) => axios.get(`${iffApi}/material/out/getApplyFile/${uuid}`, { responseType: 'blob' }),

  /** 领用单详情（按领用记录 uuid） */
  getMaterialOutDetail: (uuid) =>
    axios.get(`${iffApi}/material/out/detail/${encodeURIComponent(uuid)}`),

  /** 分页查询领用记录（statusList 多值时重复 query 参数 statusList=） */
  queryMaterialOutPage: (inputParams = {}) =>
    axios.get(
      `${iffApi}/material/out/page`,
      buildAxiosGetConfigWithRepeatedKey(inputParams, 'statusList', { omitFalseBoolean: true })
    ),

  /** 材料台账：下载导入模板 */
  downloadMaterialTemplate: () => axios.get(`${iffApi}/material/getExcelMb`, { responseType: 'blob' }),

  /** 材料台账：Excel 导入 */
  importMaterial: (formData) =>
    axios.post(`${iffApi}/material/importExcel`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
};
